import { Component } from '@angular/core';

@Component({
    selector: 'jhi-close-circle',
    templateUrl: './close-circle.component.html',
    styleUrls: ['./close-circle.component.scss'],
})
export class CloseCircleComponent {}
